import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() => ({
  customTooltip: {
    width: '300px',
    backgroundColor: 'rgba(243,252,255,0.4)',
    position: 'absolute',
    top: '-65px',
    left: '-43px',
    height: '75px',
    boxShadow: '0px 0px 44px #F3EBDF',
    borderRadius: '12px',
    display: 'flex',
    justifyContent: 'center',
  },
  customArrow: {
    color: 'rgba(220, 0, 78, 0.8)',
  },
  titileTooltip: {
    height: '100%',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '18px',
    color: '#7E6F64',
    fontFamily: ['\'Rubik\'', 'sans-serif'],
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    lineHeight: '25px',
  },
}))
